module.exports = {"140725100":"朝阳镇","140725101":"南燕竹镇","140725102":"宗艾镇","140725103":"平头镇","140725104":"松塔镇","140725105":"西洛镇","140725106":"尹灵芝镇","140725200":"平舒乡","140725201":"解愁乡","140725202":"温家庄乡","140725203":"景尚乡","140725204":"上湖乡","140725205":"羊头崖乡","140725206":"马首乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140725.json
// module id = 286
// module chunks = 0